import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef, MatSnackBar} from '@angular/material';
import { EmitterService } from '../../service/EmitterService';
import { _ } from 'underscore';
import { BlockService } from '../../service/BlockService';
import {MotifVO} from '../../model/MotifVO';
import {MotifService} from '../../service/MotifService';
import {SessionService} from '../../service/SessionService';
import * as moment from 'moment';
import {ConfirmatonDialogComponent} from '../block-temps/confirmaton-dialog/confirmaton-dialog.component';
import {isUndefined} from 'util';
import { AlertService } from '../../service/alert.service';
import {TimeZoneService} from '../../service/TimeZoneService';
import { RoleService } from '../../service/RoleService';
import { environment } from '../../../environments/environment';
import { TRAVAIL_NON_PLANIFIE_CODES, TRAVAIL_NON_PLANIFIE_HORS_PROD, TRAVAIL_NON_PLANIFIE_PROD } from '../../helpers/GlobalConstants';
import {UserService} from '../../service/UserService';
import {DATE_DEFAULT_FORMAT} from '../../model/commons/DateConstants';
import {CommentFiche} from '../../model/comment';
@Component({
  selector: 'app-dialog',
  templateUrl: 'dialog.component.html',
  styleUrls: ['./dialog.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class DialogComponent implements OnInit {
  addMotifTo: any;
  isFormation: any;
  formatTime: any = 0;
  incoherencesOld: any = [];
  incoherences: any;
  motifs: Array<MotifVO> = null;
  updateBlock: Array<any> = [];
  breakOverflowErroMsg = '';
  dataMotif: any;
  isUpdated: any = false;
  enableButton = true;
  lockUser: any;
  isUpdatedBlocks = false;
  user = null;
  country = null;
  travailNonPlanifieAcc = 0;
  group = 'Travail non planifié'
  typeMotif = {
    INCOHERENCE_INSERVICE: 'PLUS',
    INCOHERENCE_OFFSERVICE: 'MINUS'
  };
  overFlowBreaksMotifs = null;
  userValidatedBy = null;
  dateTimeRangeIsDisplayed: false;
  constructor(
    private snack: MatSnackBar,
    private blockservice: BlockService,
    private emit: EmitterService,
    public dialogRef: MatDialogRef<DialogComponent>,
    private motifservice: MotifService,
    private session: SessionService,
    private alertService: AlertService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private tzService: TimeZoneService,
    private roleService: RoleService,
    private userService: UserService) {
    tzService.setUser(data.user.username)
    this.user = data.user
    console.log('data:', data)
    if(data.addMotifTo) {
      this.addMotifTo = data.addMotifTo
    }
    const collaborator = this.userService.getUser();
    this.country = collaborator.countryCode;
    const featuresAccess = environment.featuresAccess;
    this.overFlowBreaksMotifs = featuresAccess.BLACKLISTED_BREAK_MOTIFS[this.country] || featuresAccess.BLACKLISTED_BREAK_MOTIFS.DEFAULT;
    this.isFormation = data.isFormation;
    this.userValidatedBy = data.temps.map(e => e.validatedBy).filter(e => e !== null);
    if (this.userValidatedBy.length > 0 ) {
      this.userValidatedBy = this.userValidatedBy[0];
    }else {
      this.userValidatedBy = null;
    }
    // console.log(this.userValidatedBy)

    motifservice.getMotif().subscribe((r: any) => {
      let d: any;
      d = r
      // d.push({code: 'ABSENCETAD', label: 'Absence TAD', type: 'MINUS'})
      this.motifs = d.filter(motif => {
        if(motif.code == 'INCIDENTTAD' && moment(this.blockservice.currentDate).isBefore(moment(environment.absenceTadBeginDate))) return false;
        return true;
      }).map((e, i) => {
        if(e.code == TRAVAIL_NON_PLANIFIE_PROD){ this.travailNonPlanifieAcc++; return {value: e.code, longText: e.code, text: 'PROD', type: e.type}};
        if(e.code == TRAVAIL_NON_PLANIFIE_HORS_PROD) { this.travailNonPlanifieAcc++; return {value: e.code, longText: e.code, text: 'HORSPROD', type: e.type}};
        return {value: e.code, text: e.code, type: e.type};
      });

        this.incoherences = this.incoherences.map((inc) => {
          inc['listMotifs'] = this.getMotifs(inc);
          return inc;
        })
    },
      error1 => { this.session.redirectBadRequest(error1);});
    const user = JSON.parse(localStorage.getItem('INTELCIA_OAUTH_REMOTE_USER'));
    this.incoherences = data.temps.map((d, i) => {
      return {
        id: d.id,
        motif: d.motif,
        start: d.start,
        end: d.end,
        text: d.text,
        creationDate: d.creationDate,
        addedBy: d.addedBy,
        idComment: d.idComment,
        comments : d.comments && d.comments.length>0?d.comments:[new CommentFiche()],
        ficheDate: d.ficheDate,
        uid: (d.start !== undefined ? new Date(d.start).getTime() : new Date().getTime() ),
        updated: false,
        type: d.type + '_' + d.activityType,
        duration: d.duration,
        time: d.duration,
        'break': d.break,
        ticketId: d.ticketId
      };
    });

    /*this.incoherences = data.temps.map((d, i) => {
      let block = {
        id: d.id,
        motif: d.motif,
        start: d.start,
        end: d.end,
        uid: (d.start !== undefined ? new Date(d.start).getTime() : new Date().getTime() ),
        updated: false,
        type: d.type,
        duration: d.duration,
        time: d.duration,
        'break': d.break,
        locked: d.locked,
        activityType: d.activityType,
        blockStatus: d.blockStatus,
        label: d.label,
        timeZone: d.timeZone,
        user: d.user,
        logged: d.logged,
        tag: d.tag,
        durationBreak: d.durationBreak,
        validatedBy: d.validatedBy,
        reclamationStatus: d.reclamationStatus,
        source: d.source,

        updatedBy: (user ? user.username : null)
      };
      if(d.motif) {
        block['motif'] = {'code': d.motif.code, 'label': d.motif.label, 'type': d.motif.type};
      }
      return block
    });*/
    this.incoherencesOld = JSON.parse(JSON.stringify(this.incoherences));

    this.incoherences = this.incoherences.filter(e => ((e.type + '_' + e.activityType).toLowerCase().includes('incoherence')) || (e.start == undefined))
    this.incoherences = _.sortBy(this.incoherences, 'start');
    this.updateBlock.push(data.temps);
    this.dataMotif = this.incoherences.map((d, i) => {
      const o = {};
      o[d.id] = d.motif;
      return o;
    });
  }
  ngOnInit() {
    const isupd = [];
    this.emit.getPopupEmitter().subscribe((item: Array<any>) => {
      if ( item.length > 0) {
        this.incoherences.forEach((d, i) => {
              if (d.id === item[0].id) {
                  if (d.uid === item[0].uid) {
                    item[0].text = d.text;
                    item[0].idComment = d.idComment;
                    item[0].comments =  d.comments && d.comments.length>0?d.comments:[new CommentFiche()];
                    item[0].ficheDate = d.ficheDate;
                    item[0].addedBy = d.addedBy;
                    item[0].creationDate = d.creationDate;
                    this.incoherences.splice(i, 1);
                    this.incoherences = this.incoherences.concat(item);
                  }
              }
        });
        this.incoherences = _.sortBy(this.incoherences, 'start');
        this.incoherences.forEach((d, i) => {
          if ( d.updated) {
            isupd.push(d);
            d.comments =  d.comments && d.comments.length>0?d.comments:[new CommentFiche()];
          }
        });
        this.isUpdated = (isupd.length > 0);
      }
      // console.log('>>>', this.incoherences)
    });
  }
  public CloseDialog() {
    this.dialogRef.close();
  }
  public setSizeDate(event: any, lefttime: any) {
    // console.log(event.srcElement.value, lefttime);
  }
  public getMinutes(v) {
            this.formatTime = moment.utc(v * 1000).format('HH:mm')
    return  Math.floor(v / 60)
  }
  error(message: string) {
    this.alertService.error(message, 0);
  }
  checkBreakOverflowsMotifs() {
    let bos = this.incoherences.filter(i => i.start == undefined);
    let tmp = [];
    bos.forEach(bo => {
      let codeMotif = bo.motif.code;
      if (!tmp.includes(codeMotif)) {
        tmp.push(codeMotif);
      }
    });
     console.log('-------->', bos)
    return tmp.length === bos.length;
  }
  public saveBlock() {
    if(this.hasTicketIds('INCIDENTTECH')) {
      this.snack.open("Ticket MyRequest est obligatoire", "Fermer");
      return;
    }
    if(!this.dateTimeRangeIsDisplayed){
      let enterAllowed = true;
      const o = {inco: {'default': [], 'old': [], 'new': [], 'rm': [], 'motifs': []}, breaks: []};
      let data = [];
      this.incoherences.forEach((d, i) => {
        d.ficheDate = moment(d.start).format(DATE_DEFAULT_FORMAT);
        if (d.updated) {
          d.type = d.type.split('_')[0];
          if (d.comments && d.comments.length > 0)
            d.comments[0].toUpdateComment = d.updateComment;
          data.push(d);
        }
      });

      o.breaks = this.incoherences.filter( d => d.start == undefined);
      let breakOverflows: any[] = [];
      o.breaks.forEach(breakOverflow => {
        breakOverflows.push({
          id: breakOverflow.id,
          pause: breakOverflow.break,
          duration: breakOverflow.duration,
          motif: breakOverflow.motif,
        })
      });
      if (!this.checkBreakOverflowsMotifs()) {
        this.error('Chaque dépassement de pause doit avoir un motif différent !');
        return;
      }
      if (breakOverflows.length > 0 ) {
        this.blockservice.putBreaks({breakOverflows: breakOverflows}, () => {
          /**
           * =============== Close Popup
           * */

          if(localStorage.getItem('divBlock') == '1') {
            this.CloseDialog();
          }
          this.dialogRef.afterClosed().subscribe(() => {
            this.enableButton = true;
            this.emit.emithBlock(localStorage.getItem('usernameEdit'));
          })
        });
      }
      if(data.length == 0)
      {
        this.CloseDialog();
        return;
      } else {
        this.emit.emithBlock(localStorage.getItem('usernameEdit'));
        this.enableButton = false;

        window['root'].registerListener((newBlock) => {
          if(enterAllowed){
            console.log(newBlock)
            this.blockservice.checkLockedShift(newBlock.user).subscribe((details: any) => {
              console.log('checkLockedShift response' , details);
              this.lockUser = details && details.createdBy;
              this.isUpdatedBlocks = details && details.locked;
              if(details && details.locked) return;
              /**
               * ========================== get block updated
               */
              o.inco.motifs = [];
              o.inco.old = [];
              o.inco.new = [];
              o.inco.rm = [];
              o.inco.old = JSON.parse(JSON.stringify(this.incoherencesOld));
              this.isUpdatedBlocks = false;

              data = data.map((d, i) => {
                if ( data[i].type != 'undefined') {
                  data[i].start = this.tzService.LocaleToGmt(data[i].start);
                  data[i].end   = this.tzService.LocaleToGmt(data[i].end);
                }
                return d;
              });
              let _default   = JSON.parse(JSON.stringify(data.filter( d => d.start !== undefined)));
              o.inco.new   = data.filter( d => d.start !== undefined).map((e) => {
                //e.id = null;
                return e;
              })
              let _copyBlock = [].concat(o.inco.old.filter(d => data.map(e => e.id).indexOf(d.id) == -1));
              o.inco.new = o.inco.new.concat(_copyBlock).map((e) => {
                // e.id = null;
                return e;
              })
              // for inco
              o.inco.new = JSON.parse(JSON.stringify(o.inco.new));




              /**
               * ================== Check Version Block
               * */
              if(localStorage.getItem('divBlock') == '0') {
                let realTimeold = newBlock.temps_data.filter(e => ['FULFILLED_INCOHERENCE'].indexOf(e.name) > -1);
                realTimeold = realTimeold
                  .filter(e => e.tag.toLowerCase() === 'incoherence')
                  .filter(e => ['SEUILMOINS', 'SEUILPLUS'].indexOf(e.motif.code) === -1);
                console.log(':::', realTimeold);
                // get Exclude block
                let exclude = []
                let _oldids = [];
                exclude = realTimeold.map(e => e.id)
                _oldids = this.incoherencesOld.map(m => m.id)
                if(_oldids.length > exclude.length) {
                  _oldids = realTimeold.map(e => e.id)
                  exclude = this.incoherencesOld.map(m => m.id)
                }
                let t       = [];
                _oldids.forEach((v) => {
                  if(exclude.indexOf(v) == -1) {
                    t.push(v)
                  }
                });
                console.log('===========================================')
                console.log(t)
                console.log('===========================================')

                o.inco.rm = realTimeold.filter(e => t.indexOf(e.id) > -1 && e.blockStatus != "VALIDATED");
                let checkOld = JSON.parse(JSON.stringify(this.incoherencesOld));
                let _rt = realTimeold;
                let _cd = checkOld;
                if(  checkOld.length > realTimeold.length  ) {
                  _cd = realTimeold
                  _rt = checkOld
                }
                _rt.forEach(function (_n) {
                  _cd.forEach(function (_old) {
                    if (_n.motif && _old.motif) {
                      if (_old.id == _n.id) {
                        if (_old.motif.code !== _n.motif.code) {
                          o.inco.motifs.push(_n);
                        }
                      }
                    }
                  });
                });
    //          o.inco.old = realTimeold;
                console.log(o.inco)
                if(o.inco.rm.length > 0 || o.inco.motifs.length > 0) {
                  this.isUpdatedBlocks = true
                  this.enableButton = true
                } else {
                  this.isUpdatedBlocks = false
                  this.blockservice.putBlock(_default , () => {
                    this.isUpdatedBlocks = false
                    this.enableButton = true
                    /**
                     * =============== Close Popup
                     * */

                    if(localStorage.getItem('divBlock') == '1') {
                      this.CloseDialog();
                    }
                    this.emit.emithBlock(localStorage.getItem('usernameEdit'));
                  });
                }
                console.error('>>> ', data)
                localStorage.setItem('divBlock', '1')
              }
              console.log("Someone changed the value of new Block" , newBlock);
            })
          }
          enterAllowed = false;
        });

      }
    }
  }

  // check
  hasTicketIds(code) {
    return (this.incoherences.filter(inc => inc.motif && inc.motif.code == code).length > 0)
      &&
      (this.incoherences.filter((inc) => {
        return ('ticketId' in inc &&  inc.ticketId && String(inc.ticketId).length > 0);
      }).length == 0)
  }

  dateTimeRangeDisplayFunc(event){
    this.dateTimeRangeIsDisplayed = event;
  }
  public updateTicketId(inco, value) {
    inco['updated'] = true;
    inco['ticketId'] = value
  }
  public UpdateMotif(id: any) {
    this.alertService.clear();
    this.incoherences.forEach((d, i) => {
      if (d.uid === id) {
        // console.log(this.incoherences[i])
        this.incoherences[i]['updated'] = true;
        this.incoherences[i]['ticketId'] = null;
      }
      return d;
    });
  }
  public getMotifs(obj) {
    var filteredMotifs = [];
    if (this.motifs !== null ) {
      this.motifs = this.motifs.filter(d => ['CONTROLEQUALITE','FORMATIONALTERNANCE'].indexOf(d.value) === -1);
      this.motifs = this.motifs.filter(d => ['SEUILMOINS', 'SEUILPLUS'].indexOf(d.type) === -1);
      // set Absence covid of maurice
      this.motifs = String(this.user.username).toLowerCase().startsWith('r') ?  this.motifs : this.motifs.filter(d => d.value != 'ABSENCECOVID');
      if(!this.roleService.getisFormationRelatedRole()){
        this.motifs = this.motifs.filter(motif => motif.value != 'FORMATIONINITIAL' && motif.value != 'FORMATIONMUTUALISEE' );
      }
      if (obj.break != undefined) {
        filteredMotifs = this.motifs.filter(e => this.overFlowBreaksMotifs.indexOf(e.value) == -1);
      }
      else {
        if (obj.start != undefined) {
          filteredMotifs = filteredMotifs.filter(
            d => d.value != 'BREAKOVERFLOW'
          );
        }
        filteredMotifs = this.motifs.filter(e => e.value != 'BREAKOVERFLOW' && ['EXTENSIONPAUSE', 'OUBLIEARRETPAUSE'].indexOf(e.value) == -1);
        filteredMotifs = filteredMotifs.filter(
          d => d.type === obj.motif.type && d.value != 'DEPASSEMENT');
        const featuresAccess = environment.featuresAccess.BLACKLISTED_INCOHERENCE_MOTIFS[this.country];
        if(featuresAccess) {
          const {PLUS = [], MINUS = []} = featuresAccess;
          filteredMotifs = filteredMotifs.filter(motif => {
            if (motif.type === 'PLUS') {
              return !PLUS.includes(motif.value); // exclure les PLUS
            } else if (motif.type === 'MINUS') {
              return !MINUS.includes(motif.value); // exclure les MINUS
            }
            return true; // garder tout le reste
          });
          return filteredMotifs;
        }
      }
      if(obj.motif.type == 'PLUS'){
        const formation = this.motifs.filter(motif => motif.value == 'FORMATIONINITIAL' || motif.value == 'FORMATIONMUTUALISEE' );
        filteredMotifs = [...filteredMotifs, ...formation];
      }

      if(this.addMotifTo && !this.addMotifTo.includes(obj.id)) {
        // remove motif not in addMotifTo
        filteredMotifs = filteredMotifs.filter(motif => motif.value !== "PRELOGG")
      }

      return filteredMotifs;
    }
  }

  getBreakMotifs(obj) {
    return this.getMotifs(obj) && this.getMotifs(obj).filter(motif => !['TRAVAILNONLOGUE', 'VISITEMED'].includes(motif.value));
  }

  getMotifsExcept(obj){
    return this.getMotifs(obj) && this.getMotifs(obj).filter(motif => !TRAVAIL_NON_PLANIFIE_CODES.includes(motif.value));
  }
  getMotifsOnly(obj){
    return this.getMotifs(obj) && this.getMotifs(obj).filter(motif => TRAVAIL_NON_PLANIFIE_CODES.includes(motif.value));
  }

  getActivities(incoherence){
    return ['PROD', 'HORS PROD']

  }

  public splitBreak(uid, el) {
    this.incoherences.forEach((d,i) => {
      if ( d.uid === uid ) {
        console.log('4', uid, el)
        let cp = Object.assign({}, d);;
        const o = d.duration
        const n = (el.value * 60);
        if (n < d.duration) {
          d.duration = n;
          d['updated'] = true;
          if ( (o  -  n) > 0) {
            const user = JSON.parse(localStorage.getItem('INTELCIA_OAUTH_REMOTE_USER'));
            this.incoherences.push({
              id: new Date().getTime(),
              uid: new Date().getTime(),
              motif: {'code': d.motif.code, 'label': d.motif.label, 'type': d.motif.type},
              type: d.type,
              duration: (o  -  n),
              updated: true,
              updatedBy: (user ? user.username : null),
              'break': d.break
            });
            /*const user = JSON.parse(localStorage.getItem('INTELCIA_OAUTH_REMOTE_USER'));
              let vo = {
                id: new Date().getTime(),
                uid: new Date().getTime(),
                type: d.type,
                activityType: d.activityType,
                blockStatus: d.blockStatus,
                label: d.label,
                timeZone: d.timeZone,
                user: d.user,
                logged: d.logged,
                tag: d.tag,
                durationBreak: d.durationBreak,
                validatedBy: d.validatedBy,
                reclamationStatus: d.reclamationStatus,
                source: d.source,
                motif: {'code': d.motif.code, 'label': d.motif.label, 'type': d.motif.type},
                duration: (o  -  n),
                updated: true,
                updatedBy: (user ? user.username : null),
                'break': d.break
            }
            this.incoherences.push(o);*/
          }
        }
      }
    })
  }
  refreshBlock() {
    this.dialogRef.close()
    this.dialogRef.afterClosed().subscribe(() => {
      let el = document.querySelector('.dataset .INCOHERENCE_OFF');
      if(!el) el = document.querySelector('.dataset .INCOHERENCE_ON');
      setTimeout(() => {
        el.dispatchEvent(new Event('click'))
      }, 100)
    })
  }

  changeComment(incoherence: any) {
    incoherence['updated'] = true;
    incoherence['updateComment'] = true;
  }

  checkIfUserFromTheOMICompany() {
    return this.userService.checkIfUserFromTheOMICompany();
  }

  dateGmtToLocale(incoherence: any) {
    return incoherence.comments[0].creationDate?this.tzService.GmtToLocale(incoherence.comments[0].creationDate):"";
  }
}



// WEBPACK FOOTER //
// ./src/app/view/dialog/dialog.component.ts